const entry_translations: TTranslations<{
    "location_label": string;
}> = [
    { language: "en-US", location_label: "Location" },
    { language: "es-ES", location_label: "Location" },
    { language: "nb-NO", location_label: "Location" },
    { language: "no-NO", location_label: "Location" },
    { language: "it-IT", location_label: "Location" },
    { language: "de-DE", location_label: "Location" },
    { language: "fr-FR", location_label: "Location" },
];

export default entry_translations;